import { combineReducers } from 'redux';

import {
  LIBRARY_GRATUITY_SET_OUTLETS,
  LIBRARY_GRATUITY_SET_GRATUITY_DETAIL,
  LIBRARY_GRATUITY_SET_GRATUITIES,
  LIBRARY_GRATUITY_SET_CURRENT_PAGE,
  LIBRARY_GRATUITY_SET_TOTAL_PAGE,
  LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL,
  LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL,
  LIBRARY_GRATUITY_SET_DELETED_GRATUITY,
  LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN,
  LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN,
  LIBRARY_GRATUITY_IS_SUBMITTING_FORM,
} from '../../actions/library/gratuity/constants';
import createReducer from '../../utils/createReducer';

const currentPage = createReducer(null, {
  [LIBRARY_GRATUITY_SET_CURRENT_PAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.currentPage,
});

const deletedGratuity = createReducer(null, {
  [LIBRARY_GRATUITY_SET_DELETED_GRATUITY]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.deletedGratuity,
});

const gratuities = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_GRATUITY_SET_GRATUITIES]: (draft, { payload }) => payload.gratuities,
});

const gratuityDetail = createReducer(null, {
  [LIBRARY_GRATUITY_SET_GRATUITY_DETAIL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.gratuity,
});

const isSubmittingForm = createReducer(false, {
  [LIBRARY_GRATUITY_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isSubmittingForm,
});

const openRightColumn = createReducer(false, {
  [LIBRARY_GRATUITY_OPEN_RIGHT_COLUMN]: () => true,
  [LIBRARY_GRATUITY_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_GRATUITY_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const showDeleteGratuityModal = createReducer(false, {
  [LIBRARY_GRATUITY_SHOW_DELETE_GRATUITY_MODAL]: () => true,
  [LIBRARY_GRATUITY_HIDE_DELETE_GRATUITY_MODAL]: () => false,
});

const totalPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_GRATUITY_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

export default combineReducers({
  currentPage,
  deletedGratuity,
  gratuities,
  gratuityDetail,
  isSubmittingForm,
  openRightColumn,
  outlets,
  showDeleteGratuityModal,
  totalPage,
});
